export const SPRUCE_DETAILS_STEP = "spruce-details"
export const SPRUCE_DETAILS_DESCRIPTION = "Motorcycle Description"

export const BIKE_DESCRIPTION = "bike_description"
export const BIKE_NICKNAME = "bike_nickname"
export const PRIVATE_BIKE_INFORMATION = "private_bike_information"